import { createElement } from 'src/app/core/helpers/dom';
import { EIconPath } from '../../../../../../shared/enums/icons.enum';
import { GET_GROUPING } from '../../../columns/grouping.store';
import { GET_TABLE } from '../../../table.ui.store';
import Table from '../../table/Table';
import { getSelectElementWidthPx } from '../../table/utils/select-element-width';
import { createHeaderCellElement } from './create-header-cell-element';

function pointsCoverAll(table: Table): boolean {
  return table.selectedPoints.size === table.getPoints().length && table.getPoints().length > 0;
}

function groupsCoverAll(table: Table): boolean {
  if (!table.selectedGroupCounts?.size) {
    return false;
  }

  const workspace = table.pointSearchService?.getAPIKey();
  const total = table.pointSearchService?.getTotalCount(workspace);

  return total > 0 && table.selectedPointsCount === total;
}

export function createHeaderSelectElement(): HTMLElement {
  const table = GET_TABLE();
  const grouping = GET_GROUPING();
  let src = EIconPath.ICON_CHECHMARK_TABLE_FALSE;
  const hasGroupSelection = table.selectedGroupCounts?.size > 0;
  const allPointsSelected =
    !hasGroupSelection && (table.hasSelectedAllPoints || pointsCoverAll(table));
  const allCoveredByGroups = hasGroupSelection && groupsCoverAll(table);
  const visuallyAllSelected = allPointsSelected || allCoveredByGroups;
  const isIndeterminate =
    table.isPointsSelectAllIndeterminate || (!visuallyAllSelected && hasGroupSelection);

  if (allPointsSelected) {
    table.hasSelectedAllPoints = true;

    if (!table.isPointsSelectAllIndeterminate) {
      table.deselectedPoints.clear();
    }
  }

  const checkboxClasses = ['customSiteTable__checkbox'];

  if (isIndeterminate) {
    src = EIconPath.ICON_CHECKMARK_HALF_SMALL;
    checkboxClasses.push('customSiteTable__checkbox--indeterminate');
  } else if (visuallyAllSelected) {
    src = EIconPath.ICON_CHECHMARK_TABLE_SMALL;
    checkboxClasses.push('customSiteTable__checkbox--selected');
  }

  const selectElement = createElement<HTMLElement>('span', {
    attrs: {
      class:
        'customSiteTable__checkbox__container customSiteTable__checkbox__container radial-out radial-out--header',
      id: 'sortingElement',
    },
    children: [
      createElement<HTMLElement>('img', {
        attrs: {
          class: checkboxClasses.join(' '),
          src,
        },
      }),
    ],
  });

  const className = 'table__select table__head__select';

  return createHeaderCellElement({
    className,
    center: true,
    width: getSelectElementWidthPx(grouping.length),
    resize: false,
    callback: () => {
      let selectAll = false;

      const element = selectElement.children[0] as HTMLImageElement;
      const hasExistingSelection = table.hasSelectedAllPoints || table.selectedGroupCounts.size > 0;

      if (hasExistingSelection) {
        table.tableHead.allSelected = false;
        element.src = EIconPath.ICON_CHECHMARK_TABLE_FALSE;
        element.classList.remove(
          'customSiteTable__checkbox--selected',
          'customSiteTable__checkbox--indeterminate',
        );
      } else {
        table.tableHead.allSelected = true;
        selectAll = true;
        element.src = EIconPath.ICON_CHECHMARK_TABLE_SMALL;
        element.classList.remove('customSiteTable__checkbox--indeterminate');
        element.classList.add('customSiteTable__checkbox--selected');
      }

      table.getPoints().forEach((_point, _index) => {
        if (table.tableHead.allSelected) {
          table.selectedPoints.add(_point._id);
        } else {
          table.selectedPoints.delete(_point._id);
        }
      });

      table.setSelectedPointsCount(table.selectedPoints.size);
      table.selectAllPointsCallback(selectAll);
      table.sortTable();
    },
    child: selectElement,
  });
}
